import { resourcesDriverUserActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  created: false,
  updated: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case resourcesDriverUserActions.RESOURCES_DRIVER_USER_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null
      };
    case resourcesDriverUserActions.RESOURCES_DRIVER_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case resourcesDriverUserActions.RESOURCES_DRIVER_USER:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    default:
      return state;
  }
};
